import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=3ec8ceae&"
import script from "./Portal.vue?vue&type=script&lang=ts&"
export * from "./Portal.vue?vue&type=script&lang=ts&"
import style0 from "./Portal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VScaleTransition})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ec8ceae')) {
      api.createRecord('3ec8ceae', component.options)
    } else {
      api.reload('3ec8ceae', component.options)
    }
    module.hot.accept("./Portal.vue?vue&type=template&id=3ec8ceae&", function () {
      api.rerender('3ec8ceae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shared/shared/views/Portal.vue"
export default component.exports